var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101.4 101.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f35f5d;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #eaeef9;\n      }\n\n      .cls-3 {\n        fill: #d5ddea;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_10",
    "data-name": 10
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_772",
    "data-name": "Group 772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "cls-2",
    d: "M101.4,50.8c0,14.2-5.8,27-15.1,36.2-9.1,9.1-21.7,14.6-35.6,14.6s-26.4-5.6-35.6-14.6C5.8,77.8,0,65,0,50.8,0,22.7,22.7,0,50.7,0s50.7,22.8,50.7,50.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    "data-name": "Vector 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.5,27.5l.8,64.4c0,2.2-1.8,3.9-4,3.9H20.5c-2.2,0-4-1.8-4-3.9V9.1c0-2.2,1.8-3.9,4-3.9h45.5l20.5,22.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    "data-name": "Vector 7",
    className: "cls-4",
    d: "M49.2,18.7h-22.1c-.7,0-1.3-.6-1.3-1.3s.6-1.3,1.3-1.3h22.1c.7,0,1.3.6,1.3,1.3s-.6,1.3-1.3,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    "data-name": "Vector 8",
    className: "cls-4",
    d: "M38.7,25.9h-11.6c-.7,0-1.3-.6-1.3-1.3s.6-1.3,1.3-1.3h11.5c.7,0,1.3.6,1.3,1.3s-.6,1.3-1.2,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    "data-name": "Vector 9",
    className: "cls-3",
    d: "M66,5.2v17.8c0,2.5,2.2,4.5,4.7,4.5h15.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    "data-name": "Vector 14",
    className: "cls-2",
    d: "M35.8,18.5L40.5,1.7l19.5,2.2-6.8,10.9,5.3,4.2-11.4,24.9.6-19.2-12-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    "data-name": "Vector 10",
    className: "cls-1",
    d: "M38.6,71.4c-.4,0-.8-.2-1.1-.4-.6-.6-.6-1.6,0-2.2,3.9-3.8,9-5.9,14.5-5.9s10.6,2.1,14.5,5.9c.6.6.6,1.6,0,2.2-.6.6-1.6.6-2.2,0-3.3-3.3-7.6-5-12.3-5s-9,1.8-12.3,5c-.3.3-.7.4-1.1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    "data-name": "Vector 11",
    className: "cls-1",
    d: "M43.9,48.9l2-2c.6-.6.6-1.6,0-2.2-.6-.6-1.6-.6-2.2,0l-2,2-2-2c-.6-.6-1.6-.6-2.2,0-.6.6-.6,1.6,0,2.2l2,2-2,2c-.6.6-.6,1.6,0,2.2.3.3.7.4,1.1.4s.8-.2,1.1-.4l2-2,2,2c.3.3.7.4,1.1.4s.8-.2,1.1-.4c.6-.6.6-1.6,0-2.2l-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    "data-name": "Vector 12",
    className: "cls-1",
    d: "M64.3,48.9l2-2c.6-.6.6-1.6,0-2.2-.6-.6-1.6-.6-2.2,0l-2,2-2-2c-.6-.6-1.6-.6-2.2,0-.6.6-.6,1.6,0,2.2l2,2-2,2c-.6.6-.6,1.6,0,2.2.3.3.7.4,1.1.4s.8-.2,1.1-.4l2-2,2,2c.3.3.7.4,1.1.4s.8-.2,1.1-.4c.6-.6.6-1.6,0-2.2l-2-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedIcon);
export default __webpack_public_path__ + "static/media/rejectedIcon.f533dcf7a6a16b66ea16ede18fd7e6ed.svg";
export { ForwardRef as ReactComponent };